import React from 'react'
import { ERROR_TYPE } from 'lib/errors'
import TrafiErrorMessage from './Messages/TrafiErrorMessage'
import DuplicateVehicleRestrictionMessage from './Messages/DuplicateVehicleRestrictionMessage'
import DuplicateBosRestrictionMessage from './Messages/DuplicateBosRestrictionMessage'
import TrafiVehicleRestrictionMessage from './Messages/TrafiVehicleRestrictionMessage'
import DefaultErrorMessage from './Messages/DefaultErrorMessage'
import SessionExpiredMessage from './Messages/SessionExpiredMessage'
import LoginMessage from './Messages/LoginMessage'
import DraftNotValidMessage from './Messages/DraftNotValidMessage'
import InvalidFields from './Messages/InvalidFields'
import EntityNotFoundMessage from './Messages/EntityNotFoundMessage'
import ErrorMessageWithLinkToBos from './Messages/ErrorMessageWithLinkToBos'
import BosTrafiOwnerChangedMessage from './Messages/BosTrafiOwnerChangedMessage'
import TemporaryServiceError from './Messages/TemporaryServiceError'
import RefillEventCsvMessage from './Messages/RefillEventCsvMessage'
import PaymentProcessAlreadyStarted from './Messages/PaymentProcessAlreadyStarted'
import ConfirmDeleteVehicle from './Messages/ConfirmDeleteVehicle'
import FinancingApplicationTraficomCheckErrorMessages from './Messages/FinancingApplicationTraficomCheckErrorMessages'
import ViewForbidden403 from './Messages/ViewForbidden403'
import RequireLogoutMessage from './Messages/RequireLogoutMessage'
import BosRoleSwitchMessage from 'components/BillOfSale/BosRoleSwitchMessage/BosRoleSwitchMessage'
import BosRequireLogoutMessage from './Messages/BosRequireLogoutMessage'
import OfferRequireLogoutMessage from './Messages/OfferRequireLogoutMessage'
import ActiveVehicleLimitMessage from './Messages/ActiveVehicleLimitMessage'
import UnverifiedVehicleErrorMessage from './Messages/UnverifiedVehicleErrorMessage'
import PGWUnverifiedPhoneNumberMessage from './Messages/PGWUnverifiedPhoneNumberMessage'
import PGWMissingCityMessage from 'components/Errors/Messages/PGWMissingCityMessage'

// Define what content application error should render, if anything

const errorContentResolver = (t, appError, defaultMessage = false) => {
    let errorContent = null
    switch (appError.type) {
    case ERROR_TYPE.NETWORK:
        errorContent = networkErrorContent(appError)
        break
    case ERROR_TYPE.MY_NETTIX:
        errorContent = mynettixErrorContent(appError)
        break
    case ERROR_TYPE.TRAFI:
        errorContent = trafiErrorContent(appError)
        break
    case ERROR_TYPE.INTERNAL:
        errorContent = internalErrorContent(t, appError)
        break
    case ERROR_TYPE.PGW:
        errorContent = pgwErrorContent(appError)
        break
    }

    return errorContent || (defaultMessage || <DefaultErrorMessage appError={appError} />)
}

const networkErrorContent = (appError) => {
    switch (appError.code) {
    case 401:
        return <LoginMessage appError={appError} />
    case 403:
        return <ViewForbidden403 appError={appError} />
    default:
        return null
    }
}

const internalErrorContent = (t, appError) => {
    switch (appError.code) {
    case 1003:
        return <SessionExpiredMessage appError={appError} />
    case 1006:
        return <RequireLogoutMessage appError={appError} />
    case 1007:
        return <BosRoleSwitchMessage appError={appError} />
    case 1008:
        return <BosRequireLogoutMessage appError={appError} />
    case 1009:
        return <OfferRequireLogoutMessage appError={appError} />
    case 1010:
        return <ActiveVehicleLimitMessage appError={appError} />
    default:
        return null
    }
}

const mynettixErrorContent = (appError) => {
    switch (appError.code) {
    case 10001:
        return <TrafiErrorMessage appError={appError} />
    case 10003:
        return <TrafiVehicleRestrictionMessage appError={appError} />
    case 10004:
        return <DraftNotValidMessage />
    case 10008:
        return <EntityNotFoundMessage appError={appError} />
    case 10009:
        return <DuplicateVehicleRestrictionMessage appError={appError} />
    case 10010:
        return <DuplicateBosRestrictionMessage appError={appError} />
    case 10011:
        return <InvalidFields appError={appError} />
    case 10025:
        return <InvalidFields appError={appError} />
    case 10031:
        return <ErrorMessageWithLinkToBos appError={appError} />
    case 10037:
        return <TrafiErrorMessage appError={appError} />
    case 10050:
        return <BosTrafiOwnerChangedMessage appError={appError} />
    case 10056:
        return <TemporaryServiceError appError={appError} />
    case 10060:
        return <RefillEventCsvMessage appError={appError} />
    case 10063:
        return <PaymentProcessAlreadyStarted appError={appError} />
    case 10072:
        return <FinancingApplicationTraficomCheckErrorMessages appError={appError} />
    case 10076:
        return <ConfirmDeleteVehicle appError={appError} />
    case 10112:
        return <UnverifiedVehicleErrorMessage appError={appError} />

    default:
        return null
    }
}

const trafiErrorContent = (appError) => {
    return <TrafiErrorMessage appError={appError} />
}

const pgwErrorContent = (appError) => {
    switch (appError.code) {
    case 10121:
        return <PGWUnverifiedPhoneNumberMessage appError={appError} />
    case 10127:
        return <PGWMissingCityMessage appError={appError} />
    default:
        return null
    }
}

export {
    errorContentResolver,
    mynettixErrorContent,
}
